import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
} from '@angular/core';

import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { DiagnosticRequestTabComponent } from './components/diagnostic-request-tab/diagnostic-request-tab.component';
import { DiagnosticSystemHealthTabComponent } from './components/diagnostic-system-health-tab/diagnostic-system-health-tab.component';
import { DiagnosticFileStorageTabComponent } from './components/diagnostic-file-storage-tab/diagnostic-file-storage-tab.component';

type DiagnosticsTab = 'request' | 'health' | 'file-storage';

@Component({
  selector: 'app-diagnostics',
  standalone: true,
  imports: [
    ConfirmDialogComponent,
    DiagnosticRequestTabComponent,
    DiagnosticSystemHealthTabComponent,
    DiagnosticFileStorageTabComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './diagnostics.component.html',
  styleUrls: ['./diagnostics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsComponent {
  activeTab: DiagnosticsTab = 'request';

  setTab(tab: DiagnosticsTab): void {
    if (this.activeTab === tab) return;
    this.activeTab = tab;
  }
}
